var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: _vm.editId ? "编辑标签" : "新增标签",
            top: "100px",
            width: "600px",
            "destroy-on-close": "",
            "close-on-click-modal": false,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                "label-width": "100px",
                model: _vm.formData,
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "标签名称：", prop: "tagName" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入标签名称", maxlength: "100" },
                    model: {
                      value: _vm.formData.tagName,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "tagName", $$v)
                      },
                      expression: "formData.tagName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-form-item", [
                _c(
                  "div",
                  { staticStyle: { "text-align": "right" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", loading: _vm.loading },
                        on: { click: _vm.handleSubmit },
                      },
                      [_vm._v("保存")]
                    ),
                    _vm._v(" "),
                    _c("el-button", { on: { click: _vm.closeEdit } }, [
                      _vm._v("取消"),
                    ]),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }